module.exports = __webpack_public_path__ + "static/hardwareImg-758d559f1c26ad8169a33201dae8357f.jpg";